import { render, staticRenderFns } from "./VolumeBar.vue?vue&type=template&id=466707ed&scoped=true&lang=pug&"
import script from "./VolumeBar.vue?vue&type=script&lang=js&"
export * from "./VolumeBar.vue?vue&type=script&lang=js&"
import style0 from "./VolumeBar.vue?vue&type=style&index=0&id=466707ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466707ed",
  null
  
)

export default component.exports